import { Head, Link } from "zudoku/components";

const description =
  "API reference, JavaScript SDK, cart widget, and guides for building on the Subbly subscription platform.";

export const Landing = () => (
  <main className="mx-auto flex max-w-4xl flex-col items-center gap-8 px-6 py-24 text-center">
    <Head>
      <meta name="description" content={description} />
    </Head>
    <h1 className="font-mono-heading text-4xl tracking-tight md:text-5xl">
      Build with Subbly's subscription API and SDK
    </h1>
    <p className="max-w-2xl text-lg text-muted-foreground">
      Explore the API reference, install the SDK or the widget, and ship
      your integration on the Subbly subscription platform.
    </p>
    <div className="flex flex-wrap justify-center gap-4">
      <Link
        to="/get-started/overview"
        className="btn-subbly btn-subbly-primary px-8 py-3 no-underline"
      >
        Get started
      </Link>
      <Link
        to="/api/storefront"
        className="btn-subbly btn-subbly-outline px-8 py-3 no-underline"
      >
        API reference
      </Link>
    </div>
  </main>
);
